import { mainnet } from 'viem/chains';
import { mapDynamicChainToWagmi } from './mappers/chain.js';

const getWagmiChainsFromDynamicChains = (dynamicChains) => {
    const mappedChains = dynamicChains.map(mapDynamicChainToWagmi);
    return mappedChains.length > 0 ? mappedChains : [mainnet];
};

export { getWagmiChainsFromDynamicChains };
